import localStorage from './localStorage'
import privateKeyNames from './privateKeyNames'
import notifications from './notifications'
import modals from './modals'
import tradeTicker from './TRADE_TICKERS'
import tokenDecimals from './TOKEN_DECIMALS'
import pairTypes from './PAIR_TYPES'
import tokenStandards from './TOKEN_STANDARDS'

export default {
  localStorage,
  tradeTicker,
  privateKeyNames,
  tokenDecimals,
  notifications,
  pairTypes,
  modals,
  tokenStandards,
}
